import SButton from "./SButton";
import accessControlled from "components/access-control/access-controlled";
import ViewAccessMethods from "ViewAccessMethods";

const AdminSButton = accessControlled(SButton, ViewAccessMethods.hasAdminAccess);

export default AdminSButton;
